export default __webpack_public_path__ + "static/media/yurucamp.91a61956.gif";